(function () {
  "use strict";

  var API_BASES = ["https://dev-api.teleadapt.com", "https://api.teleadapt.com"];
  var SITE_KEY = "0x4AAAAAAEDHIc-JmyqtxRyG";
  var TURNSTILE_URL = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
  var SUCCESS_RESULTS = ["created", "updated", "resubscribed"];
  var turnstilePromise;

  function loadTurnstile() {
    var script;
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (turnstilePromise) return turnstilePromise;
    turnstilePromise = new Promise(function (resolve, reject) {
      function loaded() { window.turnstile ? resolve(window.turnstile) : reject(new Error("turnstile_unavailable")); }
      script = document.querySelector('script[src="' + TURNSTILE_URL + '"]');
      if (!script) {
        script = document.createElement("script");
        script.src = TURNSTILE_URL;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
      script.addEventListener("load", loaded, { once: true });
      script.addEventListener("error", reject, { once: true });
    });
    return turnstilePromise;
  }

  function endpoint(root) {
    var base = String(root.dataset.taApiBase || "https://api.teleadapt.com").replace(/\/$/, "");
    if (API_BASES.indexOf(base) === -1) throw new Error("Subscription service configuration is unavailable.");
    return base + "/api/v1/subscribers";
  }

  function field(root, name) {
    return root.querySelector('[data-ta-subscribe-field="' + name + '"]');
  }

  function value(control) {
    return control ? String(control.value || "").trim() : "";
  }

  function validEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function messageFor(result) {
    if (result === "already_pending") return "Please check your inbox to complete your subscription, or try again later.";
    if (result === "cleaned_address") return "This email address cannot currently be subscribed. Please use another address or contact TeleAdapt.";
    if (result === "turnstile_failed") return "Verification failed. Please try again.";
    if (result === "validation_error") return "Please review your details and try again.";
    if (result === "service_unavailable" || result === "upstream_service_error") return "Subscription is temporarily unavailable. Please try again later.";
    return "We could not complete your subscription. Please try again.";
  }

  function initialise(root) {
    var first = field(root, "first-name");
    var last = field(root, "last-name");
    var email = field(root, "email");
    var company = field(root, "company");
    var button = root.querySelector("[data-ta-subscribe-submit]");
    var status = root.querySelector("[data-ta-subscribe-status]");
    var turnstileContainer = root.querySelector("[data-ta-subscribe-turnstile]");
    var apiEndpoint;
    var submitting = false;
    var widgetId = null;

    if (!first || !last || !email || !button || !status || !turnstileContainer) return;
    try { apiEndpoint = endpoint(root); }
    catch (error) { setStatus(error.message); button.disabled = true; return; }

    function setStatus(message) {
      status.textContent = message;
      status.hidden = !message;
    }

    function removeWidget() {
      if (widgetId !== null && window.turnstile && window.turnstile.remove) {
        try { window.turnstile.remove(widgetId); } catch (_error) { }
      }
      widgetId = null;
      turnstileContainer.replaceChildren();
    }

    function setBusy(busy) {
      submitting = busy;
      button.disabled = busy;
      root.setAttribute("aria-busy", busy ? "true" : "false");
      root.dataset.taSubscribeState = busy ? "submitting" : "idle";
    }

    function validate() {
      var invalid = [];
      [[first, value(first)], [last, value(last)]].forEach(function (item) {
        item[0].removeAttribute("aria-invalid");
        if (!item[1]) invalid.push(item[0]);
      });
      email.removeAttribute("aria-invalid");
      if (!validEmail(value(email))) invalid.push(email);
      invalid.forEach(function (control) { control.setAttribute("aria-invalid", "true"); });
      if (invalid[0]) invalid[0].focus();
      return invalid.length === 0;
    }

    function recover(message) {
      setBusy(false);
      setStatus(message);
      root.dataset.taSubscribeState = "error";
      removeWidget();
    }

    function send(token) {
      var payload = {
        first_name: value(first),
        last_name: value(last),
        email: value(email).toLocaleLowerCase(),
        company: value(company) || null,
        turnstile_token: token,
        marketing_consent: true
      };
      window.fetch(apiEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      }).then(function (response) {
        return response.json().then(function (body) { return { response: response, body: body }; });
      }).then(function (outcome) {
        if (outcome.response.ok && outcome.body.success === true && SUCCESS_RESULTS.indexOf(outcome.body.result) !== -1) {
          root.dataset.taSubscribeState = "success";
          setStatus("");
          window.location.assign("/pages/subscribe-thank-you");
          return;
        }
        recover(messageFor(outcome.body && outcome.body.result));
      }).catch(function () {
        recover("We could not confirm whether your subscription was received. Please wait before trying again.");
      });
    }

    function completeVerification(token) {
      removeWidget();
      setStatus("Submitting your subscription…");
      send(token);
    }

    function submit(event) {
      event.preventDefault();
      if (submitting) return;
      if (!validate()) { setStatus("Please complete the required fields."); return; }
      setBusy(true);
      setStatus("Submitting your subscription…");
      loadTurnstile().then(function (turnstile) {
        widgetId = turnstile.render(turnstileContainer, {
          sitekey: SITE_KEY,
          theme: "auto",
          callback: completeVerification,
          "error-callback": function () { recover("Verification failed. Please try again."); },
          "expired-callback": function () { recover("Verification expired. Please try again."); },
          "timeout-callback": function () { recover("Verification timed out. Please try again."); }
        });
      }).catch(function () { recover("Verification is temporarily unavailable. Please try again."); });
    }

    root.addEventListener("submit", submit);
    setStatus("");
    root.dataset.taSubscribeInitialised = "true";
    root.dataset.taSubscribeState = "idle";
  }

  function initialiseAll() {
    document.querySelectorAll("[data-ta-subscribe-form]").forEach(function (root) {
      if (root.dataset.taSubscribeInitialised !== "true") initialise(root);
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initialiseAll, { once: true });
  else initialiseAll();
})();
